import axios from '@/lib/AxApi';

export default
{
  async selectTrainingBlock(params, cb)
  {
    try
    {
      var response = await axios.get('/TrainingExamCustom/selectTrainingBlock',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectTrainingChapter(params, cb)
  {
    try
    {
      var response = await axios.get('/TrainingExamCustom/selectTrainingChapter',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
}